<!-- 画像拡大モーダルコンポーネント -->
<template>
  <div class="pinch-in-card">
    <div class="modal-inner flexcenter">
      <div class="pinch-type card-voice">
        <button class="modal-close" @click="clickClose"></button>
        <div class="pinch-inInner">
          <div class="item">
            <div class="flexbox">
                <div class="card">
                  <div class="image"><img :src="pinchInParams.pinchInImagePath"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 共通処理
import common from '@/mixin/common'
import runmode from '@/mixin/runmode'
import * as constants from '@/store/constants'
import { mapGetters } from "vuex";

export default {
  name: 'PinchInImg',
  props: {
    pinchInImagePath: String,
  },
  mixins: [
    common,
    runmode
  ],
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      "pinchInParams"
    ]),
  },
  created () {
  },
  methods: {
    /**
     * 閉じるボタン押下時の処理
     */
    clickClose: function() {
      this.log("PinchInImg start clickClose");

      this.$store.dispatch("setShowPinchIn", false);
      
      if (this.$store.getters.lessonState === constants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("TPro recievePinchOut: set lessonState: " + constants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", constants.LESSON_STATE_RESTART);
      }
    },
  },
  mounted: function () {
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>
  @import 'src/assets/style/card';
</style>



// WEBPACK FOOTER //
// PinchInImg.vue?6e3b6872